import { useState, useEffect, useCallback, useRef } from "react";
import Papa from 'papaparse';
import * as XLSX from 'xlsx';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from "react-helmet-async";
import {
  Link as RouterLink,
  useNavigate,
  useParams,
  useLocation,
  NavLink,
} from "react-router-dom";
import { useForm } from "react-hook-form";
import { Formik, Form, Field } from "formik";
import { toast } from "react-toastify";
import $ from "jquery";
// @mui
import { styled } from "@mui/material/styles";
import { Button, Typography, Container, Box, Modal } from "@mui/material";
import { format } from "date-fns";
import * as userActions from "../../actions/userActions";
import config from "../../config";
import { encryptData } from "../../utils/cryptoUtils";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle";
import "../common.scss";
import * as leadActions from "../../actions/leadActions";
 
import AccessDenied from "../common/AccessDenied";
 
 // ----------------------------------------------------------------------

const StyledContent = styled("div")(({ theme }) => ({
  maxWidth: 480,
  margin: "auto",
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  padding: theme.spacing(12, 0),
}));

const styles = {
  overlay: {
    position: 'fixed',
    top: 0, left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0,0,0,0.45)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1300,
  },
  modal: {
    position: 'relative',
    width: '90%',
    height: '80%',
    backgroundColor: '#fff',
    borderRadius: '10px',
    overflow: 'hidden',
  },
  iframe: {
    width: '100%',
    height: '100%',
  },
  closeButton: {
    position: 'absolute',
    top: 10,
    right: 15,
    fontSize: '24px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
  },
  // ---- SweetAlert-style popup ----
  sweetOverlay: {
    position: 'fixed',
    top: 0, left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0,0,0,0.45)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1400,
  },
  sweetCard: {
    position: 'relative',
    width: '100%',
    maxWidth: 420,
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '2.25rem 1.75rem 1.75rem',
    textAlign: 'center',
    boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
  },
  sweetCloseBtn: {
    position: 'absolute',
    top: 12,
    right: 14,
    fontSize: '20px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: '#999',
    lineHeight: 1,
  },
  sweetIconCircle: {
    width: 72,
    height: 72,
    borderRadius: '50%',
    border: '3px solid #f0ad4e',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 1.25rem',
    fontSize: 34,
    color: '#f0ad4e',
    fontWeight: 'bold',
  },
  sweetTitle: {
    fontSize: '1.2rem',
    fontWeight: 700,
    color: '#2b2b2b',
    marginBottom: '0.6rem',
  },
  sweetText: {
    fontSize: '0.85rem',
    color: '#666',
    marginBottom: '1.6rem',
    lineHeight: 1.5,
  },
  sweetBtnRow: {
    display: 'flex',
    justifyContent: 'center',
    gap: '12px',
    flexWrap: 'wrap',
  },
  sweetBtnPrimary: {
    backgroundColor: '#28a746d5',
    height: '40px',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    padding: '5px 16px',
    fontSize: '0.75rem',
    fontWeight: 500,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  sweetBtnOutline: {
    height: '40px',
    backgroundColor: '#fff',
    color: '#f0ad4e',
    border: '1px solid #f0ad4e',
    borderRadius: '6px',
    padding: '10px 22px',
    fontSize: '0.75rem',
    fontWeight: 500,
    cursor: 'pointer',
  },
  // ---- Inline notice bar (replaces popup) ----
  inlineNoticeBox: {
    position: 'relative',
    width: '100%',
    backgroundColor: '#fff8ec',
    border: '1px solid #f0ad4e',
    borderRadius: '8px',
    padding: '1rem 3rem 1rem 1.25rem',
    marginBottom: '1rem',
  },
  inlineNoticeClose: {
    position: 'absolute',
    top: 10,
    right: 14,
    fontSize: '20px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: '#999',
    lineHeight: 1,
  },
  inlineNoticeTitle: {
    fontSize: '1rem',
    fontWeight: 700,
    color: '#8a6116',
    marginBottom: '0.35rem',
    display: 'block',
  },
  inlineNoticeText: {
    fontSize: '0.85rem',
    color: '#7a5a12',
    marginBottom: '0.9rem',
    lineHeight: 1.5,
  },
  inlineNoticeBtnRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flexWrap: 'wrap',
  },
  inlineNoticeBtnPrimary: {
    backgroundColor: '#28a746d5',
    height: '38px',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    padding: '5px 16px',
    fontSize: '0.75rem',
    fontWeight: 500,
    cursor: 'pointer',
  },
  inlineNoticeBtnOutline: {
    height: '38px',
    backgroundColor: '#fff',
    color: '#f0ad4e',
    border: '1px solid #f0ad4e',
    borderRadius: '6px',
    padding: '10px 22px',
    fontSize: '0.75rem',
    fontWeight: 500,
    cursor: 'pointer',
  },
};

// ----------------------------------------------------------------------
const RCfromChassis = (props) => {
  const { id, actionName } = useParams();
  const location = useLocation();
  const {
    actions} = props;
   
  const [leadId, setLeadId] = useState(""); 
   
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();
  const navigate = useNavigate();

  const [showLeadCommunicationDetails, setShowLeadCommunicationDetails] =
    useState(false);
  const [allSourceData, setAllSource] = useState([]);
  const [allMasterProfiles, setAllMasterProfiles] = useState([]);
  const [allInteractionTypeData, setAllInteractionTypeData] = useState([]);
  const [allLeadStatusData, setAllLeadStatusData] = useState([]);
  const [allInteractions, setAllInteractions] = useState([]);
  const [allLeadCheckLists, setAllLeadCheckLists] = useState([]);
  const [pageHeading, setPageHeading] = useState("");
  const [questions, setQuestions] = useState([]);

  const [addModulePermissionStatus, setAddModulePermissionStatus] =
    useState(false);
  const [editModulePermissionStatus, setEditModulePermissionStatus] =
    useState(false);
  const [userHasPermission, setUserHasPermission] = useState(true);
  const [permissions, setPermissions] = useState([]);

  const [panDetailsInfoName, setPanDetailsInfoName] = useState("");
  const [chassisNumberDetailsInfoName, setChassisNumberDetailsInfoName] = useState("");
  const [panDetailsInfoDoB, setPanDetailsInfoDoB] = useState("");
  const [panDetailsInfoGender, setPanDetailsInfoGender] = useState("");
  const [panDetailsInfoAddress, setPanDetailsInfoAddress] = useState("");
  const [leadPanDetails, setLeadPanDetails] = useState("");
  const [showTicketListDetails, setShowTicketListDetails] = useState(false);
  const [allTicketData, setAllTicketData] = useState([]);

  const [showListDetails, setShowListDetails] = useState(false);
  const [allGroupData, setAllGroupData] = useState([]);
  const [getAllUsersListData, setAllUsersListData] = useState([]);

  const [allLeadGstByLeadData, setAllLeadGstByLeadData] = useState([]);
  const [allLeadItrByLeadData, setAllLeadItrByLeadData] = useState([]);
  const [allLeadBankStatementByLeadData, setAllLeadBankStatementByLeadData] =
    useState([]);
    const [allLeadBankStatementCount, setAllLeadBankStatementCount] =
    useState(0);
  const [userRoleType, setUserRoleType] = useState("User");
  const [loggeInUserID, setLoggeInUserID] = useState("");
  const [isCrifUser, setIsCrifUser] = useState(true);
  const [isExternalUser, setIsExternalUser] = useState(false);

  const [allStates, setAllStates] = useState([]);
  const [allAddressTypes, setAllAddressTypes] = useState([]);
  const [showNote, setShowNote] = useState("");
  const [showNoteNoteByCredit, setShowNoteNoteByCredit] = useState("");
  const [showHistory, setShowHistory] = useState(false);
  const [allPrefillTemplateNameData, setAllPrefillTemplateNameData] = useState(
    []
  );
  const [allCampaigns, setAllCampaigns] = useState([]);
  const [showActionLeadInfo, setShowActionLeadInfo] = useState(false);

  const [selectedCampaign, setSelectedCampaign] = useState("");
  const [selectedAssignedGroup, setSelectedAssignedGroup] = useState("");
  const [assignedUser, setAssignedUser] = useState("");

  const [isSentToCredit, setIsSentToCredit] = useState(true);

  const [allLeadActivity, setAllLeadActivity] = useState([]);
  const [preloaderStatus, setPreloaderStatus] = useState(false);
  const [preloaderStatusChassisNumber, setPreloaderStatusChassisNumber] = useState(false);
  const [preloaderBulkChassisNumber, setPreloaderBulkChassisNumber] = useState(false);
  const [actionType, setActionType] = useState("");
  const [activeTabName, setActiveTabName] = useState("basic");
  const [activeTab, setActiveTab] = useState("communication");

  const [allLeadCheckListScore, setAllLeadCheckListScore] = useState([]);
  const [allLeadCheckListDynamicScore, setAllLeadCheckListDynamicScore] =
    useState([]);

  const [creditAllLeadCheckLists, setCreditAllLeadCheckLists] = useState([]);
  const [scoreCard, setScoreCard] = useState("");
  const [allShipment, setAllShipment] = useState([]);
  const [leadStatusFlag, setLeadStatusFlag] = useState(false);
  const [outputBefiscHtml, setOutputBefiscHtml] = useState("");
  const [isExternalUserContent, setIsExternalUserContent] = useState("");
  const [mobileReadOnly, setMobileReadOnly] = useState(false);

  const [allOem, setAllOem] = useState([]);
  const [allOemUsage, setAllOemUsage] = useState([]);

  const [allFiSaveHistory, setAllFiSaveHistory] = useState([]);

  // lead Type start
  const [getAllChildsData1, setAllChildsData1] = useState([]);
  const [selectedOutcome, setSelectedOutcome] = useState("");

  const [preloaderAadharStatus, setPreloaderAadharStatus] = useState(false);
  const [preloaderAadharOTPVerifyStatus, setPreloaderAadharOTPVerifyStatus] =
    useState(false);
  const [aadharVerifiedByName, setAadharVerifiedByName] = useState("");
  const [aadharVerifiedDate, setAadharVerifiedDate] = useState("");
  const [leadAadharDetails, setLeadAadharDetails] = useState("");
  const [skipAadharNumberToSave, setSkipAadharNumberToSave] = useState(true);
  const [aadharVerifiedStatus, setAadharVerifiedStatus] = useState(false);
  const [aadharOTPSentStatus, setAadharOTPSentStatus] = useState("0");
  const [aadharRefid, setAadharRefid] = useState("0");
  const [aadharValidationID, setAadharValidationID] = useState("");
  const [referenceId, setReferenceId] = useState("");
  const [isNameStyled, setIsNameStyled] = useState(false);
  const [isDobStyled, setIsDobStyled] = useState(false);
  const [isAddressStyled, setIsAddressStyled] = useState(false);
  const [isCityStyled, setIsCityStyled] = useState(false);
  const [isDistrictStyled, setIsDistrictStyled] = useState(false);
  
  const [isPinStyled, setIsPinStyled] = useState(false);
  const [senttoCreditStatus, setSenttoCreditStatus] = useState(false);
  const [enableCamDetailsStatus, setEnableCamDetailsStatus] = useState(false);
  const [vivritiChecklistStatus, setVivritiChecklistStatus] = useState(false);
  const [allDealers, setAllDealers] = useState([]);
  const selectRefDO = useRef(null);
  const selectRefSL = useRef(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [iframeUrl, setIframeUrl] = useState('');
  const [aadharDigiVerifiedByName, setAadharDigiVerifiedByName] = useState("");
  const [aadharDigiVerifiedDate, setAadharDigiVerifiedDate] = useState("");
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [csvData, setCsvData] = useState([]);
  const [bulkApiResponseArr, setBulkApiResponseArr] = useState([]);

  const [showExistsModal, setShowExistsModal] = useState(false);
  const [existsData, setExistsData] = useState(null);
  const [checkingChassis, setCheckingChassis] = useState(false);
  const debounceTimerRef = useRef(null);

  const [showBulkExistsModal, setShowBulkExistsModal] = useState(false);
  const [bulkExistingData, setBulkExistingData] = useState([]);
  const [bulkMissingData, setBulkMissingData] = useState([]);
  const [bulkCheckSummary, setBulkCheckSummary] = useState({ total: 0, existing: 0, missing: 0 });
  const [preloaderBulkCheck, setPreloaderBulkCheck] = useState(false);
  
  
  const [formValues, setFormValues] = useState({
    chassis_number: "",
  });

  // Common normalizer — DB (existing) aur fresh API dono ka output ek hi shape mein: { chassis_number, result: {actual fields} }
    const normalizeChassisItem = (item, source = 'existing') => {
      if (source === 'existing') {
        const actualData = item?.result?.result ? item.result.result : item.result;
        return {
          chassis_number: item?.chassis_number,
          result: actualData || {},
        };
      }
      const actualData = item?.result || {};
      return {
        chassis_number: item?.chassis_number,
        result: actualData,
      };
    };

  const handleChange = (e) => {
  const { name, value } = e.target;
  setFormValues({
    ...formValues,
    [name]: value,
  });

  if (name === "chassis_number") {
    if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
    debounceTimerRef.current = setTimeout(() => {
      checkChassisExistence(value);
    }, 700); // 700ms — typing ruke to check
  }
};

const handleViewExisting = () => {
  // Existing cached data ko same table format me dikhana
  const normalized = normalizeChassisItem(
    { chassis_number: existsData.chassis_number, result: existsData.result },
    'existing'
  );
  setBulkApiResponseArr([normalized]);
  setShowExistsModal(false);
};

const handleRunFreshCheck = () => {
  setShowExistsModal(false);
  handleChassisNumberDetails('single', true); // 👈 true = run_again, backend check skip karega
};

const handleFileUpload = (event) => {
  const file = event.target.files[0];
  if (!file) return;

  Papa.parse(file, {
    header: true,
    skipEmptyLines: true,
    complete(results) {
      const chassisArray = results.data
        .map(row => row.chassis_number?.trim()) // Adjust this key if needed
        .filter(Boolean); // Remove undefined/null/empty values

      setCsvData(chassisArray);
      console.log('Chassis Numbers:', chassisArray);
    },
  });
};

  const handleSendToAPI = async () => {
    if (!csvData || csvData.length === 0) return;

    setPreloaderBulkCheck(true);
    const bulkResult = await checkChassisNumbersBulkExistence(csvData);
    setPreloaderBulkCheck(false);

    if (bulkResult.existing_count > 0) {
      // kuch already DB me hain — user se pucho
      setBulkExistingData(bulkResult.existing);
      setBulkMissingData(bulkResult.missing);
      setBulkCheckSummary({
        total: bulkResult.total,
        existing: bulkResult.existing_count,
        missing: bulkResult.missing_count,
      });
      setShowBulkExistsModal(true);
    } else {
      // koi bhi DB me nahi mila, seedha sabka fresh API run
      handleChassisNumberDetails('multiple', true, csvData, []);
    }
  };

const handleChassisNumberDetails = (actionName = 'single', isRunAgain = false, overrideChassisNumbers = null, mergeExistingData = []) => {
    let chassisNumbers = [];
    if (actionName === 'multiple') {
      setPreloaderBulkChassisNumber(true);
      chassisNumbers = overrideChassisNumbers || csvData;
    } else {
      setPreloaderStatusChassisNumber(true);
      chassisNumbers = [formValues.chassis_number];
    }

    // 👇 naya - agar bulk me sirf existing hi the aur missing khali hai, API hit karne ki zaroorat nahi
    if (actionName === 'multiple' && chassisNumbers.length === 0) {
      setPreloaderBulkChassisNumber(false);
      setBulkApiResponseArr(
        mergeExistingData.map((e) => ({ chassis_number: e.chassis_number, result: e.result }))
      );
      return;
    }

    const params = {
      chassis_numbers: chassisNumbers,
      "brief": 'check_chassis_number',
      'actionName': actionName,
      'identifier': isRunAgain ? 'run_again' : ''
    };
    const requestData = encryptData(params);
    const response = actions.validateToolsDetails(requestData);

    response
      .then((result) => {
        if (result.data.data && result.data.data.exists) {
          setPreloaderStatusChassisNumber(false);
          setExistsData(result.data.data);
          setShowExistsModal(true);
          return;
        }

        setLeadPanDetails("");
        if (result.data.success === 1) {

          if(actionName === 'multiple'){
            setPreloaderBulkChassisNumber(false);
          }else{
            setPreloaderStatusChassisNumber(false);
          }
          toast.success(result.data.message, { position: "top-right" });

          let apiResponseObj = [];
          if (
            Object.prototype.hasOwnProperty.call(result.data.data, "befiscApiRunStatus") &&
            result.data.data.befiscApiRunStatus
          ) {
            if (Object.prototype.hasOwnProperty.call(result.data.data, "bulkApiResponse")) {
              apiResponseObj = (result.data.data.bulkApiResponse || []).map((item) =>
                normalizeChassisItem(item, 'fresh')
              );
            }
          }

          // 👇 DB se aaya existing data + fresh API se aaya data, dono ab same normalized shape mein
          const mergedExisting = mergeExistingData.map((e) => normalizeChassisItem(e, 'existing'));
          setBulkApiResponseArr([...mergedExisting, ...apiResponseObj]);

          setOutputBefiscHtml("");
          setChassisNumberDetailsInfoName("");
        } else {
          if(actionName === 'multiple'){
            setPreloaderBulkChassisNumber(false);
          }else{
            setPreloaderStatusChassisNumber(false);
          }
          toast.error(result.data.message, { position: "top-right" });
        }
      })
      .catch((error) => {
        if(actionName === 'multiple'){
            setPreloaderBulkChassisNumber(false);
          }else{
            setPreloaderStatusChassisNumber(false);
          }
        toast.error(error, { position: "top-right" });
      });
  };

  const checkChassisExistence = useCallback((chassisNo) => {
  if (!chassisNo || chassisNo.trim().length < 5) {
    setExistsData(null);
    setShowExistsModal(false);
    return;
  }
  setCheckingChassis(true);
  const params = { chassis_number: chassisNo.trim() };
  const requestData = encryptData(params);
  const response = actions.checkChassisNumberExist(requestData);

  response
    .then((result) => {
      setCheckingChassis(false);
      if (result.data.success === 1 && result.data.data.exists) {
        setExistsData(result.data.data);
        setShowExistsModal(true); // auto popup as soon as typing pauses
      } else {
        setExistsData(null);
        setShowExistsModal(false);
      }
    })
    .catch(() => {
      setCheckingChassis(false);
    });
}, [actions]);

// Naya - submit button click pe existence check ke liye
const checkChassisExistenceForSubmit = (chassisNo) => {
  return new Promise((resolve) => {
    if (!chassisNo || chassisNo.trim().length < 5) {
      resolve({ exists: false });
      return;
    }
    const params = { chassis_number: chassisNo.trim() };
    const requestData = encryptData(params);
    const response = actions.checkChassisNumberExist(requestData);

    response
      .then((result) => {
        if (result.data.success === 1 && result.data.data.exists) {
          setExistsData(result.data.data);
          resolve({ exists: true });
        } else {
          resolve({ exists: false });
        }
      })
      .catch(() => resolve({ exists: false }));
  });
};

// Naya - submit button ka onClick handler
const handleSubmitClick = async () => {
  const chassisNo = formValues.chassis_number;
  if (!chassisNo || chassisNo.trim() === "") return;

  setPreloaderStatusChassisNumber(true);
  const { exists } = await checkChassisExistenceForSubmit(chassisNo);
  setPreloaderStatusChassisNumber(false);

  if (exists) {
    setShowExistsModal(true); // popup dikhega, user "Run Again" ya "View Existing" choose karega
  } else {
    handleChassisNumberDetails('single'); // fresh chassis hai, seedha paid API
  }
};

const checkChassisNumbersBulkExistence = (chassisNumbersArr) => {
  return new Promise((resolve) => {
    const params = { chassis_numbers: chassisNumbersArr };
    const requestData = encryptData(params);
    const response = actions.checkChassisNumbersBulkExist(requestData); // 👈 naya redux action

    response
      .then((result) => {
        if (result.data.success === 1) {
          resolve(result.data.data);
        } else {
          resolve({
            total: chassisNumbersArr.length,
            existing_count: 0,
            missing_count: chassisNumbersArr.length,
            existing: [],
            missing: chassisNumbersArr,
          });
        }
      })
      .catch(() => {
        resolve({
          total: chassisNumbersArr.length,
          existing_count: 0,
          missing_count: chassisNumbersArr.length,
          existing: [],
          missing: chassisNumbersArr,
        });
      });
  });
};

// Convert nested object into flat Excel-friendly object — top-level reusable function
const flattenObject = (obj, prefix = "", result = {}) => {
  Object.keys(obj || {}).forEach((key) => {
    const value = obj[key];
    const newKey = prefix ? `${prefix}.${key}` : key;

    if (
      value !== null &&
      typeof value === "object" &&
      !Array.isArray(value)
    ) {
      flattenObject(value, newKey, result);
    } else if (Array.isArray(value)) {
      result[newKey] = JSON.stringify(value);
    } else {
      result[newKey] = value ?? "";
    }
  });

  return result;
};

const downloadExistingChassisExcel = () => {
  if (!bulkExistingData || bulkExistingData.length === 0) {
    toast.error("No existing chassis data available for download.", {
      position: "top-right",
    });
    return;
  }

  const excelData = bulkExistingData.map((item) => {
    const normalized = normalizeChassisItem(item, 'existing');
    const flatData = flattenObject(normalized.result);

    return {
      "Chassis Number": item?.chassis_number || "",
      "Created By": item?.created_by_name || "",
      "Created At": item?.created_at || "",
      ...flatData,
    };
  });

  const worksheet = XLSX.utils.json_to_sheet(excelData);

  // Auto width for columns
  const columnWidths = Object.keys(excelData[0] || {}).map((key) => {
    const maxLength = Math.max(
      key.length,
      ...excelData.map((row) =>
        String(row[key] ?? "").length
      )
    );

    return {
      wch: Math.min(Math.max(maxLength + 2, 12), 50),
    };
  });

  worksheet["!cols"] = columnWidths;

  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(
    workbook,
    worksheet,
    "Existing Chassis Data"
  );

  const date = new Date().toISOString().slice(0, 10);

  XLSX.writeFile(
    workbook,
    `existing_chassis_data_${date}.xlsx`
  );
};

// Naya — table mein jitni bhi entries dikh rahi hain (existing + fresh API dono), unko excel mein export karo
const downloadAllResultsExcel = () => {
  if (!bulkApiResponseArr || bulkApiResponseArr.length === 0) {
    toast.error("No data available for download.", {
      position: "top-right",
    });
    return;
  }

  const excelData = bulkApiResponseArr.map((item) => {
    const flatData = flattenObject(item?.result || {});
    return {
      "Chassis Number": item?.chassis_number || "",
      ...flatData,
    };
  });

  const worksheet = XLSX.utils.json_to_sheet(excelData);

  const columnWidths = Object.keys(excelData[0] || {}).map((key) => {
    const maxLength = Math.max(
      key.length,
      ...excelData.map((row) => String(row[key] ?? "").length)
    );
    return {
      wch: Math.min(Math.max(maxLength + 2, 12), 50),
    };
  });

  worksheet["!cols"] = columnWidths;

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Chassis Results");

  const date = new Date().toISOString().slice(0, 10);
  XLSX.writeFile(workbook, `chassis_results_${date}.xlsx`);
};

const handleUseDbAndRunRemaining = () => {
  setShowBulkExistsModal(false);

  if (bulkMissingData.length === 0) {
    // sab already DB me the
    setBulkApiResponseArr(
      bulkExistingData.map((e) => normalizeChassisItem(e, 'existing'))
    );
    return;
  }

  // sirf missing wale chassis ka paid API chalega, existing DB se merge hoga
  handleChassisNumberDetails('multiple', true, bulkMissingData, bulkExistingData);
};

const handleRunAllFresh = () => {
  setShowBulkExistsModal(false);
  // sabka dobara fresh API run, DB data ignore
  handleChassisNumberDetails('multiple', true, csvData, []);
};

    

  if (!userHasPermission) {
    // Redirect or render an access denied message
    return <AccessDenied />;
  }

  return (
    <>
      <Helmet>
        <title> {leadId === "" ? "Chassis Number Information" : "Chassis Number Information"} Lead | Ckers </title>
      </Helmet>
      <Container>
        <div className="row align-items-center"> 
          <div className="col-md-12">
            <Typography variant="h4" sx={{ mb: 5 }}>
              {leadId === "" ? (
                "Check Chassis Number Information"
              ) : (
                <>
                  {pageHeading}
                  <br />
                  <Typography variant="body3" sx={{ color: "red" }}>
                    {isExternalUserContent}
                  </Typography>
                </>
              )}
            </Typography>
          </div> 
        </div>
        <div id="main-wrap" className="mb-5">
              <div className="tab-content" id="pills-tabContent">
              <form>
            <div className="row">
              <div className="col-md-5">
                <div className="form-group">
                  <label htmlFor="chassis_number">
                    <span>
                      Chassis Number{" "}
                      <a style={{ color: "red" }}>* </a>
                    </span>
                    <input
                      type="tel"
                      id="chassis_number"
                      name="chassis_number"
                      className="form-control "
                      {...register("chassis_number")}
                      value={formValues.chassis_number}
                      onChange={handleChange}
                      readOnly={
                        userRoleType === "Credit" ||
                        leadStatusFlag === true ||
                        mobileReadOnly === true
                      }
                    /> 
                            <button
                              type="button"
                              className="btn btn-success float-right validate-phone"
                              onClick={handleSubmitClick}
                            >
                              {preloaderStatusChassisNumber && (
                                <>
                                  <div className="spinner-border small-preloader" role="status">
                                    <span className="visually-hidden"> Loading...</span>
                                  </div>
                                </>
                              )}
                            Submit
                            </button>
                  </label>
                  {errors.chassis_number && (
                    <span className="required">
                      {" "}
                      This field is required.
                    </span>
                  )}
                </div> 
              </div>
               <div className="col-md-2">&nbsp;</div>    
               <div className="col-md-5" style={{ borderRight: "1px solid #aaa" }}>
                <div className="form-group">
                  <label htmlFor="chassis_number">
                    <span>
                      Import CSV with Multiple Chassis Numbers{" "}
                      <a style={{ color: "red" }}>* </a>
                    </span>
                          <input type="file" accept=".csv" onChange={handleFileUpload} />
                          <button type="button"
                            className="btn btn-success float-right" 
                            onClick={handleSendToAPI}
                            disabled={csvData.length === 0 || preloaderBulkCheck}
                          >
                            {preloaderBulkCheck && (
                              <div className="spinner-border small-preloader" role="status">
                                <span className="visually-hidden">Checking...</span>
                              </div>
                            )}
                            {preloaderBulkChassisNumber && (
                              <div className="spinner-border small-preloader" role="status">
                                <span className="visually-hidden">Loading...</span>
                              </div>
                            )}
                            Send to API
                          </button>
                  </label>
                </div>
              </div>
            </div>
          </form> 

          {showExistsModal && existsData && (
            <div style={styles.inlineNoticeBox}>
              <button
                style={styles.inlineNoticeClose}
                onClick={() => setShowExistsModal(false)}
              >
                &times;
              </button>
              <span style={styles.inlineNoticeTitle}>
                This chassis number is already Run
              </span>
              <div style={styles.inlineNoticeText}>
                Last run by: <strong>{existsData?.created_by_name || 'N/A'}</strong>
                {existsData?.created_at && (
                  <>
                    {" "}| Date: {existsData.created_at}
                  </>
                )}
              </div>
              <div style={styles.inlineNoticeBtnRow}>
                <button style={styles.inlineNoticeBtnPrimary} onClick={handleViewExisting}>
                   View Existing Data
                </button>
                <button style={styles.inlineNoticeBtnOutline} onClick={handleRunFreshCheck}>
                  Run Again
                </button>
              </div>
            </div>
          )}

          {showBulkExistsModal && (
            <div style={styles.inlineNoticeBox}>
              <button
                style={styles.inlineNoticeClose}
                onClick={() => setShowBulkExistsModal(false)}
              >
                &times;
              </button>
              <span style={styles.inlineNoticeTitle}>
                Some chassis numbers have already been checked
              </span>
              <div style={styles.inlineNoticeText}>
                Out of <strong>{bulkCheckSummary.total}</strong> chassis numbers,{" "}
                <button type="button" onClick={downloadExistingChassisExcel}
                  style={{border: "none", background: "transparent", padding: 0, margin: 0, color: "#007bff", fontWeight: 700, textDecoration: "underline", cursor: "pointer",}} title="Download existing chassis data">
                  {bulkCheckSummary.existing}
                </button>{" "}
                already exist in the database,{" "}
                <strong>{bulkCheckSummary.missing}</strong> are new.
              </div>
              <div style={styles.inlineNoticeBtnRow}>
                <button
                  style={styles.inlineNoticeBtnPrimary}
                  onClick={handleUseDbAndRunRemaining}
                >
                  Use Existing Data + Run {bulkCheckSummary.missing} New
                </button>

                <button
                  style={styles.inlineNoticeBtnOutline}
                  onClick={handleRunAllFresh}
                >
                  Run All Again ({bulkCheckSummary.total})
                </button>
              </div>
            </div>
          )}

           {bulkApiResponseArr.length > 0 && (
             <div className="d-flex justify-content-end mb-2">
               <button
                 type="button"
                 className="btn btn-warning"
                 onClick={downloadAllResultsExcel}
               >
                 Download Excel
               </button>
             </div>
           )}
           <div className="table-wrap table-responsive">
            <table className="table table-hover" id="exportBeatPlanExcelFile">
                <thead>
                    <tr>
                        <th className="text-nowrap">Chassis NO</th>
                        <th className="text-nowrap-">Result</th> 
                    </tr>
                </thead>

                <tbody>
                    {bulkApiResponseArr.map((item, index) => (
                        <tr key={index}>
                            <td>{item?.chassis_number}</td>
                            <td> 
                               <div className="row">
                               <div className="col-md-6">
                              <ul>
                              <li><strong>Chassis Number : </strong> {item?.result?.chassis_number}</li>
                              <li><strong>Registration Number : </strong> {item?.result?.registration_number}</li>
                              <li><strong>Owner Name : </strong> {item?.result?.user_name}</li>
                              <li><strong>Vehicle Make/Model : </strong> {item?.result?.vehicle_make_model}</li>
                              <li><strong>Fuel Type : </strong> {item?.result?.vehicle_fuel_description}</li>
                              <li><strong>Fitness Upto : </strong> {item?.result?.fit_upto}</li>
                              <li><strong>Registration Date : </strong> {item?.result?.registration_date}</li>
                              <li><strong>Vehicle Age : </strong> {item?.result?.vehicle_age}</li>
                              <li><strong>Insurance Policy No : </strong> {item?.result?.insurance?.policyNumber}</li>
                              <li><strong>Insurance Company : </strong> {item?.result?.insurance?.company}</li>
                              <li><strong>Insurance Valid Till : </strong> {item?.result?.insurance?.validTill}</li>
                              <li><strong>Owner Address : </strong> {item?.result?.user_present_address}</li>
                            </ul>
                            </div>
                            <div className="col-md-6">
                            <ul>
                              <li><strong>Father Name : </strong> {item?.result?.father_name}</li>
                              <li><strong>Financer : </strong> {item?.result?.financer}</li>
                              <li><strong>Vehicle category : </strong> {item?.result?.vehicle_category}</li>
                              <li><strong>Vehicle class description : </strong> {item?.result?.vehicle_class_description}</li>
                              <li><strong>Vehicle cubic capacity : </strong> {item?.result?.vehicle_cubic_capacity}</li>
                              <li><strong>Vehicle gross weight : </strong> {item?.result?.vehicle_gross_weight}</li>
                              <li><strong>Vehicle maker description : </strong> {item?.result?.vehicle_maker_description}</li>
                              <li><strong>Vehicle manufactured date : </strong> {item?.result?.vehicle_manufactured_date}</li>
                              <li><strong>Vehicle number of cylinders : </strong> {item?.result?.vehicle_number_of_cylinders}</li>
                              <li><strong>Vehicle seating capacity : </strong> {item?.result?.insurance?.vehicle_seating_capacity}</li>
                              <li><strong>Month year remaining for insurance exp : </strong> {item?.result?.insurance?.month_year_remaining_for_insurance_exp}</li>
                              <li><strong>City : </strong> {item?.result?.insurance?.city}</li>
                              <li><strong>State : </strong> {item?.result?.state}</li>
                            </ul>
                            </div>
                            </div>
                            
                            </td>
                        </tr>
                    ))}

                    {bulkApiResponseArr.length < 1 && (
                        <>
                            <tr>
                                <td colSpan={2} className='text-center py-3 fw-bold'>No record found</td>
                            </tr>
                        </>
                    )}
                </tbody>
            </table>
        </div>
         
        </div>
        </div>
      </Container> 
    </>
  );
};
function mapStateToProps(state) {
  return {
    leadsData: state.leadsData,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      Object.assign(
        leadActions.default
      ),
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RCfromChassis);